<template>
  <div>
    <editor v-model="editorValue" :init="init" />
  </div>
</template>
    
  <script setup>
import {reactive, ref, watch, toRefs} from "vue";
import tinymce from "tinymce/tinymce.js";
import "tinymce/skins/ui/oxide/skin.css";

import "tinymce/plugins/quickbars";
import "tinymce/plugins/autolink";
import "tinymce/plugins/link";
import "tinymce/plugins/paste";
import "tinymce-i18n/langs5/fr_FR.js";

import Editor from "@tinymce/tinymce-vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  plugins: {
    type: [String, Array],
    default: "advlist autolink lists link image charmap print preview anchor paste",
  },
  toolbar: {
    type: [String, Array],
    default: " link  ",
  },
  setup: (editor) => {
    editor.ui.registry.addButton("myCustomLinkButton", {
      text: "Mon Lien Spécifique",
      onAction: () => {
        const url = "https://www.example.com"; // URL de votre lien spécifique
        const selectedText = editor.selection.getContent({ format: "text" });

        // Ajoutez target="_blank" à la balise <a> pour ouvrir dans une nouvelle fenêtre
        const linkHtml = `<a href="${url}" target="_blank">${selectedText}</a>`;
        editor.execCommand("mceInsertContent", false, linkHtml);
      },
    });
  },
});

const emit = defineEmits(["update:modelValue"]);

const init = reactive({
  selector: "textarea",
  language: "fr_FR",
  height: 200,
  menubar: false,
  content_style: "body {font-size: 12pt; }",
  skin: false,
  lists_indent_on_tab: false,
  advlist_bullet_styles: "square",
  plugins: props.plugins,
  toolbar: props.toolbar,
  quickbars_insert_toolbar: false,
  paste_as_text: true,
  smart_paste: false,
  paste_data_images: false,
  paste_remove_styles_if_webkit: true,
  paste_webkit_styles: "color font-size",
  branding: false,
  forced_root_block: false, // Désactive l'utilisation de <p> par défaut
  force_br_newlines: true, // Utilise <br> pour les retours à la ligne
  force_p_newlines: false, // N'utilise pas de <p> pour les paragraphes

});

const {modelValue} = toRefs(props);
const editorValue = ref(props.value);

watch(modelValue, (newValue) => {
  editorValue.value = newValue;
});

watch(editorValue, (newValue) => {
  emit("update:modelValue", newValue);
});
</script>